
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import teleport from 'vue2-teleport';

@Component({components: {teleport}})
export default class BottomSheets extends Vue {
  @Prop({default:true})
  canClose?: boolean; // 닫기 가능함?

  isOpened = false;

  static objects = [] as Array<BottomSheets>;

  open() {
    this.$nextTick().then(()=>{
      this.isOpened = true;
    })
    
  }

  close() {
    BottomSheets.closeAll();
    // 노닫기 옵션의 경우(예: 톡톡 카테고리 선택) 안고르면 뒤로 가기
    this.canClose || this.$router.go(-1);
  }

  static closeAll() {
    BottomSheets.objects.forEach((obj) => {
      obj.isOpened = false;
    });
  }

  created() {
    BottomSheets.objects.push(this);
  }

  deactivated() {
    BottomSheets.closeAll();
  }
}
